export default {
    list: [],
    account: null,

}
